import { Breadcrumb as BreadcrumbComponent } from '@chakra-ui/react';
import { ReactElement, useContext } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Breadcrumb } from 'types/breadcrumbs';
import { ProtectedRoutes, RouteType } from 'types/Routes';
import { ChevronRightIcon } from 'assets/icons/v2';
import { useCurrentRoute } from '../../../hooks/utils/useCurrentRoute';
import { BreadcrumbContext } from '../../providers/BreadcrumbProvider';

export const crumbs: Breadcrumb[] = [
  {
    path: `${ProtectedRoutes.BASE}`,
    name: 'Home',
  },
  {
    path: `${ProtectedRoutes.NEWS}`,
    name: 'Novaheal News',
  },
  {
    path: ProtectedRoutes.KNOWLEDGE,
    name: 'Kategorien',
  },
  {
    path: ProtectedRoutes.SETTINGS,
    name: 'Profile',
  },
  {
    path: ProtectedRoutes.PROFILE,
    name: 'Persönliche Daten',
  },
  {
    path: ProtectedRoutes.PASSWORD,
    name: 'Passwort ändern',
  },
  {
    path: ProtectedRoutes.LEGAL,
    name: 'Rechtliches',
  },
  {
    path: ProtectedRoutes.SUPPORT,
    name: 'Support',
  },
  {
    path: ProtectedRoutes.PAYMENT_MANAGEMENT,
    name: 'Premium Management',
  },
  {
    path: ProtectedRoutes.VOUCHER,
    name: 'Zugangscode eingeben',
  },
  {
    path: ProtectedRoutes.REFERRAL,
    name: 'Freundschaftscode',
  },
];

export const Breadcrumbs = (): ReactElement | null => {
  const location = useLocation();
  const { additionalBreadcrumbs, showBreadcrumbs } = useContext(BreadcrumbContext);
  const { routeType } = useCurrentRoute(location);
  const currentPathWithSearch = `${location.pathname}${location.search}`;

  const isNotDefinedRoute = routeType === RouteType.NOT_DEFINED;
  const customCrumbs = additionalBreadcrumbs.length > 0 ? additionalBreadcrumbs : [];
  const filteredBreadcrumbs = crumbs.filter(
    (crumb: Breadcrumb) => crumb.path && location.pathname.includes(crumb.path)
  );
  const currentBreadcrumbs = [...filteredBreadcrumbs, ...customCrumbs];
  const shouldShowCrumbs = currentBreadcrumbs.length > 1 && showBreadcrumbs && !isNotDefinedRoute;

  return shouldShowCrumbs ? (
    <BreadcrumbComponent.Root p="30px 20px" textStyle="body.s.regular" overflowX="hidden">
      <BreadcrumbComponent.List>
        {currentBreadcrumbs.map((route: Breadcrumb, index: number) => {
          const last = index === currentBreadcrumbs.length - 1;

          return (
            route.name &&
            route.path && (
              <>
                <BreadcrumbComponent.Item key={`${route.path}::item`}>
                  <BreadcrumbComponent.Link
                    asChild
                    color={
                      route.path === location.pathname || route.path === currentPathWithSearch
                        ? 'text.primary'
                        : 'text.info'
                    }
                    whiteSpace="nowrap"
                    overflow="hidden"
                    maxW="220px"
                    textOverflow="ellipsis"
                    textStyle="body.s.regular"
                  >
                    <Link to={route.path}>{route.name}</Link>
                  </BreadcrumbComponent.Link>
                </BreadcrumbComponent.Item>
                {!last && (
                  <BreadcrumbComponent.Separator key={`${route.path}::sep`}>
                    <ChevronRightIcon color="icon.info" boxSize="14px" />
                  </BreadcrumbComponent.Separator>
                )}
              </>
            )
          );
        })}
      </BreadcrumbComponent.List>
    </BreadcrumbComponent.Root>
  ) : null;
};
